import React from 'react';
import moment from 'moment';
import Field from '../../Field';
import { Fields } from '../InfoContainer/info-container-styles';

const tourTypeLabels = {
  inperson: 'In-person',
  virtual: 'Virtual',
  selfguided: 'Self-guided',
  '3d': '3D',
  '3D': '3D'
};

const TourDetailsInfo = ({ schedule }) => {
  const nextTour = Array.isArray(schedule) ? schedule[0] : null;
  const confirmedDate = nextTour?.confirmedDate
    ? moment(nextTour.confirmedDate)
    : null;

  return (
    <Fields>
      <Field
        isRequired
        label="Date"
        value={{
          from: confirmedDate ? confirmedDate.format('YYYY-MM-DD') : 'N/A'
        }}
        date
      />
      <Field
        isRequired
        label="Time"
        value={{ from: confirmedDate ? confirmedDate.format('LT') : 'N/A' }}
        time
      />
      <Field
        isRequired
        label="Tour type"
        value={tourTypeLabels[nextTour?.tourType] || 'N/A'}
      />
    </Fields>
  );
};

export default TourDetailsInfo;
